import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_0 } from '../../colors';

/* eslint-disable max-statements */
export class TreeDiagram extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.TreeMap);
    chart.data = data;

    chart.dataFields.value = 'value';
    chart.dataFields.name = 'name';
    chart.dataFields.children = 'children';

    chart.zoomable = false;
    chart.hiddenState.properties.opacity = 0;
    chart.colors.step = 2;

    // -- level 0 series
    const level0Series = chart.seriesTemplates.create('0');
    const level0Column = level0Series.columns.template;
    level0Column.strokeWidth = 0;

    // -- level 1 series
    const level1Series = chart.seriesTemplates.create('1');
    const level1Column = level1Series.columns.template;
    level1Column.strokeWidth = 1;
    level1Column.strokeOpacity = 0.2;
    // level1Column.column.cornerRadius(4, 4, 4, 4);
    // level1Column.fillOpacity = 0.8;
    // level1Column.stroke = am4core.color(COLOR_SURFACE_1);

    const level1Bullet = level1Series.bullets.push(new am4charts.LabelBullet());
    level1Bullet.locationY = 0.5;
    level1Bullet.locationX = 0.5;
    level1Bullet.label.text = '{name}';
    level1Bullet.label.fill = am4core.color(COLOR_FONT_0);

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ height: '512px' }} />;
  }
}

TreeDiagram.propTypes = {
  chartId: PropTypes.string.isRequired
  // data: PropTypes.arrayOf(
  //   PropTypes.shape({ name_display: PropTypes.string.isRequired, count: PropTypes.number.isRequired })
  // ).isRequired
};
